<template>
    <div>
        <v-dialog
            persistent
            width="350"
            v-model="display">
            <v-card flat>
                <v-card-title>{{ title }}</v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <div class="text-center" v-if="formLength">
                        <label>{{ $t('exchange_msg') }}</label>
                    </div>
                    <v-form
                        v-else
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            v-for="(currency, i) in currencyWithoutBase"
                            :key="i"
                            dense
                            v-model="currency.rate"
                            :placeholder="currency.name"
                            :suffix="abbreviation"
                            :prefix="`1 `+currency.abbreviation+` = `"
                            >
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn :disabled="formLength" @click="submit" text>{{ $t('add_line') }}</v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "ExchangeRateLineDialog",
    components: {
       RetryDialog 
    },
    props: {
        currency: {
            type: Array,
            required: false
        },
        currency_id: {
            type: Number,
            required: false
        },
        abbreviation: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            display: true,
            valid:false,
            loading: {
                data: false
            },
            form: [],
            // rules: {
            //     rate: [
            //         v => !!v || this.$t('rules_required')
            //     ]
            // }
        }
    },
    computed: {
        ...mapState('accounting/currency', ["currencies"]),
        editMode() {
            return !this.notEditMode;
        },
        notEditMode() {
            return !this.currency.length;
        },
        title() {
            return this.$t('exchange_equivelant');
        },
        formLength() {
            if(this.form.length == 1) return true;
            else return false;
        },
        currencyWithoutBase(){
            if(this.editMode) return  this.form.filter(echo => echo.currency_id != this.currency_id);
            else return this.form.filter(echo => echo.id != this.currency_id);
        }
        
    },
    methods: {
        ...mapActions('accounting/currency', ["fetchCurrencies"]),
        async createdDataFetch() {
            try {
                this.loading.data = true;
                await this.fetchCurrencies();
                if(this.editMode) {
                    let currnecyDataProps = this._.clone(this.currency);
                    let newCurrencyFromDataBase =  this.currencies.filter(echo => !currnecyDataProps.some(e => e.currency_id === echo.id));
                    newCurrencyFromDataBase.forEach(currency => {
                        currency.currency_id = currency.id;
                        currency.rate = ''
                        currnecyDataProps.push(currency);
                    });
                    this.form = currnecyDataProps;
                } else {
                    await this.fetchCurrencies();
                    this.form = this._.clone(this.currencies);
                    console.log('currencies', this.form);
                    this.form.forEach(currency => {
                        currency.currency_id = currency.id;
                        currency.rate = ''
                    });
                }
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        close() {
            this.$emit('close');
        },
        submit() {
            this.$emit('submit', this.form.filter(echo => echo.id != this.currency_id));
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        checkCurrencyLength() {

        }
        
    },
    created () {
        console.log('tag', '')
        this.createdDataFetch();
    },
}
</script>